import { useAtomValue } from 'jotai/index';
import { metricGroupsAtom } from '@/atoms/queries/tableColumns';
import { loadable } from '@/utils/jotai';

/** This component eagerly loads reference data required by the radar template modal */
export const RadarTemplateReferenceData = () => {
  useAtomValue(loadable(metricGroupsAtom)); // For step 2
  return null;
};
